import React from 'react';
import { Modal } from './Modal';
import { calculateStarRatingTier } from '../../domain/constants';
import './RatingBadge.css';
import './HelpModal.css';

const RATING_TIERS = [
    calculateStarRatingTier(5.0),
    calculateStarRatingTier(4.5),
    calculateStarRatingTier(4.0),
    calculateStarRatingTier(3.0),
    calculateStarRatingTier(2.0),
    calculateStarRatingTier(1.0)
];

interface RatingInfoModalProps {
    isOpen: boolean;
    onClose: () => void;
    leagueName: string;
    currentRating?: number;
}

export const RatingInfoModal: React.FC<RatingInfoModalProps> = ({ isOpen, onClose, leagueName, currentRating }) => {
    const currentTier = currentRating !== undefined ? calculateStarRatingTier(currentRating) : null;
    
    return (
        <Modal isOpen={isOpen} onClose={onClose} className="help-modal">
            <h2>Star Rating Explained</h2>
            <p>A player's star rating is a quick measure of their current ability <strong>relative to the average player in {leagueName}</strong>.</p>
            <p>It takes into account their skill and current form. A player who is a 'Superstar' in League Two might only be 'Decent' in the Prem Division.</p>
            <ul style={{ listStyle: 'none', padding: 0, marginTop: '16px' }}>
                {RATING_TIERS.map(tier => (
                    <li key={tier.label} className={`help-modal-row ${currentTier?.label === tier.label ? 'highlight-row' : ''}`}>
                        <span className={`rating-badge ${tier.className}`} style={{ flexShrink: 0 }}>{tier.label}</span>
                        <span>{tier.description}</span>
                    </li>
                ))}
            </ul>
            <div className="modal-actions">
                <button className="button" onClick={onClose}>Close</button>
            </div>
        </Modal>
    );
};
